import { render } from "./TradeInSpecial.vue?vue&type=template&id=4c86b3c4"
import script from "./TradeInSpecial.vue?vue&type=script&lang=js"
export * from "./TradeInSpecial.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__